var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import dayjs from "dayjs";
import * as React from "react";
import { withTypes } from "react-final-form";
import { generatePath, useHistory, useParams } from "react-router-dom";
import { ConcertCard } from "@components/site/ConcertCard";
import { Footer } from "@components/site/Footer";
import { siteConcert, siteConcerts, studentCheckout } from "@urls";
import { useBookingTicketMutation, useConcertsQuery } from "@graphql";
import { Modal } from "@components/student/Modal";
import { Button } from "@components/student/Button";
import { useTranslation } from "react-i18next";
import * as s from "./ConcertPage.sss";
import { LayoutContainer } from "@/components/student/LayoutContainer";
import { ScheduleType } from "@/constants";
import { ConcertUserInfo } from "@/containers/site/ConcertUserInfo";
import { NavBarContainer } from "@/containers/student/NavBar";
import { selectedConcertVar } from "@/local-state/vars";
import { Loader } from "@/components/ui/Loader";
export const ConcertPage = () => {
    const { Form } = withTypes();
    const { concertId } = useParams();
    const { t } = useTranslation();
    const history = useHistory();
    const { data, loading } = useConcertsQuery();
    const [bookingTicket] = useBookingTicketMutation();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const concertInfo = React.useMemo(() => data && data.concerts.filter(({ id }) => id === Number(concertId))[0], [concertId, data]);
    const concertsFilter = React.useMemo(() => {
        if (!data || !Array.isArray(data.concerts)) {
            return [];
        }
        const currentDate = dayjs();
        return data.concerts
            .filter(concert => {
            const concertDate = dayjs(concert.time);
            return !concertDate.isBefore(currentDate, 'day');
        });
    }, [data]);
    const onSubmitUserInfo = (concertSelect) => __awaiter(void 0, void 0, void 0, function* () {
        selectedConcertVar(Object.assign(Object.assign(Object.assign({}, concertInfo), concertSelect), { returnUrl: "/", concertId: Number(concertId) }));
        yield bookingTicket({
            variables: {
                concertId: Number(concertId),
                rowPlaceIds: concertSelect.placeIds
            }
        });
        history.push(generatePath(studentCheckout, {
            scheduleType: ScheduleType.Concerts,
            concertId,
        }));
    });
    React.useEffect(() => {
        if (history.location.hash === "#thanks") {
            setIsModalOpen(true);
        }
    }, [history.location.hash]);
    if (concertId && concertInfo) {
        return (React.createElement(Form, { onSubmit: (e) => __awaiter(void 0, void 0, void 0, function* () {
                onSubmitUserInfo(e);
            }), render: () => React.createElement(ConcertUserInfo, { concertId: concertId, title: concertInfo.hall.name, time: concertInfo.time }) }));
    }
    if (loading) {
        return React.createElement(Loader, null);
    }
    if (!loading && !concertsFilter) {
        return null;
    }
    return (React.createElement("div", { className: s.root },
        React.createElement(NavBarContainer, { position: "fixed", theme: "primary" }),
        React.createElement(LayoutContainer, null,
            React.createElement("div", { className: s.subscriptionsBlock }, concertsFilter.map(concert => (React.createElement(ConcertCard, { key: concert.id, className: s.card, concert: Object.assign(Object.assign({}, concert), { date: dayjs(concert.time).format("DD/MM/YYYY"), time: dayjs(concert.time).format("HH:mm"), price: 0, description: "" }), onSubmit: () => history.push(generatePath(siteConcert, {
                    concertId: concert.id,
                })) }))))),
        React.createElement(Footer, null),
        React.createElement(Modal, { className: s.modal, isOpen: isModalOpen, theme: "orange", withClose: true, onRequestClose: () => setIsModalOpen(false) },
            React.createElement("div", { className: s.modalTitle }, t("student~Дякуємо за покупку!")),
            React.createElement("div", { className: s.modalText }, t("student~Квитки будуть на вказаній пошті протягом декількох хвилин.")),
            React.createElement(Button, { className: s.saveChanges, theme: "secondaryOrange", onClick: () => {
                    setIsModalOpen(false);
                    history.push(siteConcerts);
                } }, t("student~Ок")))));
};
export default ConcertPage;
